import { X } from "lucide-react";

export default function InstructionModal({ isOpen, onClose, theme, allowOutsideClick = true }) {
    if (!isOpen) return null;

    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: allowOutsideClick ? "rgba(0, 0, 0, 0.7)" : "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: "20px",
        pointerEvents: allowOutsideClick ? "auto" : "none",
    };

    const modalStyle = {
        backgroundColor: theme.bg || "#1a1a1a",
        color: theme.text || "#ffffff",
        borderRadius: "12px",
        padding: "30px",
        maxWidth: "600px",
        width: "100%",
        maxHeight: "80vh",
        overflowY: "auto",
        position: "relative",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
        border: `1px solid ${theme.border || "#333"}`,
        pointerEvents: "auto",
    };

    const closeButtonStyle = {
        position: "absolute",
        top: "15px",
        right: "15px",
        background: "transparent",
        border: "none",
        color: theme.text || "#ffffff",
        cursor: "pointer",
        padding: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        transition: "background-color 0.2s",
    };

    const titleStyle = {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "20px",
        marginTop: "0",
    };

    const contentStyle = {
        fontSize: "16px",
        lineHeight: "1.6",
    };

    const handleOverlayClick = (e) => {
        if (allowOutsideClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleOverlayTouch = (e) => {
        if (allowOutsideClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            style={overlayStyle}
            onClick={handleOverlayClick}
            onTouchEnd={handleOverlayTouch}
        >
            <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                <button
                    style={closeButtonStyle}
                    onClick={onClose}
                    title="Закрити"
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = theme.inputBg || "#2a2a2a";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                    }}
                >
                    <X size={24} />
                </button>

                <h2 style={titleStyle}>Як користуватися AI офіціантом</h2>
                <div style={contentStyle}>
                    <p>
                        Вітаємо! Це AI-офіціант, який допоможе вам зробити замовлення.
                    </p>
                    <p>
                        Ви можете написати, що хочете замовити,
                        і офіціант допоможе вам з вибором страв з меню.
                    </p>
                    <p>
                        Також доступні функції:
                        <br />- покликати офіціанта
                        <br />- оформити замовлення
                        <br />- залишити анонімний відгук
                        <br />- отримати рекомендації по ваших вподобаннях
                        <br />- попросити принести щось (рахунок, прибори, воду, тощо)
                    </p>
                    <p>
                        Просто напишіть що вам потрібно та натисніть "Надіслати",
                        щоб почати розмову!
                    </p>
                </div>
            </div>
        </div>
    );
}
